module.exports = __webpack_public_path__ + "img/aimer_20210901114649.f827b8bf.png";